import React from 'react';
import b_ from 'b_';
import { Map } from '../Map';
import { Link } from '../Link';
import { Text } from '../Text';
import './Contacts.scss';
import { headings } from '../../data';

const b = b_.lock('Contacts');

const Contacts = ({
  email,
  phones,
  address,
  coordinates
}) => (
  <div className={b()}>
    <div className={b('textPane')}>
      <Text type='h1'>{headings['/contacts']}</Text>
      <ul className={b('list')}>
        <li className={b('listItem', { address: true })}>{`Адрес офиса: \n${address}`}</li>
        {/* <li className={b('listItem', { worktime: true })}>{'Режим работы офиса: \n'}</li> */}
        <li className={b('listItem', { email: true })}>
          {'Электронная почта: \n'}
          <Link as='a' href={`mailto:${email}`}>{email}</Link>
        </li>
        <li className={b('listItem', { phone: true })}>
          {phones.reduce((acc, phone, i) => {
            acc.push(i ? ', \n' : 'Телефоны: \n');
            acc.push(
              <Link as='a' href={`tel:${phone}`} key={i}>{phone}</Link>
            );
            return acc;
          }, [])}
        </li>
        {/* <li className={b('listItem')}>
          {'Организация: \n'}
          {legal}
        </li> */}
      </ul>
    </div>
    <Map
      balloonContent={address}
      className={b('map')}
      center={coordinates}
    />
  </div>
);

export default Contacts;
